import UntitledIcon, { TIconName } from '@payaca/untitled-icons';
import React, { FunctionComponent, type JSX } from 'react';
import Button from './Button';
import './Button.sass';
import { ButtonColourVariant, ButtonStyleVariant } from './enums';

type Props = {
  isDisabled?: boolean;
  onClick?: () => void;
  onClickDisabled?: () => void;
  isProcessing?: boolean;
  colourVariant?: ButtonColourVariant;
  hasBoxShadow?: boolean;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  isOutlined?: boolean;
  label?: string;
  icon: TIconName;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  styleVariant?: ButtonStyleVariant;
};

const IconButton: FunctionComponent<Props> = (props: Props): JSX.Element => {
  /* eslint-disable react/no-children-prop */
  return (
    <div className="icon-button-container">
      <Button
        {...props}
        children={<UntitledIcon name={props.icon} />}
        className={`icon-button ${props.size ? `icon-${props.size}` : ''} ${
          props.className ? props.className : ''
        }`}
        styleVariant={props.styleVariant || ButtonStyleVariant.CIRCULAR}
      />
      {props.label && (
        <span className="text-blue-500 font-normal">{props.label}</span>
      )}
    </div>
  );
};

export default IconButton;
